import { useDispatch, useSelector } from "react-redux";
import { APP_ADMIN_ROLE, APP_SUPER_ADMIN_ROLE, TORK_READER_ROLE, TORK_ADMIN_ROLE } from "../Constants";
import { setJwtToken } from "../../state/slices/AuthSlice";


const useAuth = () => {
    const roles = useSelector(state => state.auth.roles);
    const jwtToken = useSelector(state => state.auth.jwtToken);
    const email = useSelector(state => state.auth.username);
    const name = useSelector(state => state.auth.name);
    const dispatch = useDispatch();
    const isAdmin = () => {
        return roles.includes(APP_ADMIN_ROLE)
    }
    const hasTorkAccess = () => {
        return roles.includes(TORK_READER_ROLE) || roles.includes(TORK_ADMIN_ROLE)
    }
    const isTorkAdmin = () => {
        return roles.includes(TORK_ADMIN_ROLE)
    }
    const isSuperAdmin = () => {
        return roles.includes(APP_SUPER_ADMIN_ROLE)
    }
    const setJwt = (token) => {
        dispatch(setJwtToken(token))
    }

    return { jwtToken, email, name, isAdmin, hasTorkAccess, isTorkAdmin, isSuperAdmin, setJwt }
}

export default useAuth